module.exports = __webpack_public_path__ + "img/about-22.ca0ee756.png";